import React from 'react';
interface BonusCardProps {
  title: string;
  description: string;
  imageUrl?: string;
  icon?: React.ReactNode;
}
export function BonusCard({
  title,
  description,
  imageUrl,
  icon
}: BonusCardProps) {
  return <div className="bg-white rounded-lg shadow-lg overflow-hidden border-2 border-green-600 relative" data-id="element-351">
      <div className="absolute top-4 right-4 z-10" data-id="element-352">
        <span className="bg-gradient-to-r from-red-600 to-red-700 text-white px-4 py-2 rounded-full text-sm font-bold shadow-lg" data-id="element-353">
          GRATIS HOY
        </span>
      </div>

      {imageUrl ? <div className="relative h-48 overflow-hidden" data-id="element-354">
          <img src={imageUrl} alt={title} className="w-full h-full object-cover" data-id="element-355" />
          <div className="absolute inset-0 bg-gradient-to-b from-transparent via-green-900/50 to-green-900/90" data-id="element-356" />
          <div className="absolute bottom-0 left-0 right-0 p-6" data-id="element-357">
            <h3 className="text-2xl md:text-3xl font-bold text-white display-font" data-id="element-358">
              {title}
            </h3>
          </div>
        </div> : <div className="relative h-48 bg-gradient-to-br from-green-600 to-green-800 flex items-center justify-center" data-id="element-359">
          {icon && <div className="text-white text-6xl" data-id="element-360">{icon}</div>}
          <div className="absolute bottom-0 left-0 right-0 p-6" data-id="element-361">
            <h3 className="text-2xl md:text-3xl font-bold text-white display-font" data-id="element-362">
              {title}
            </h3>
          </div>
        </div>}

      <div className="p-6" data-id="element-363">
        <p className="text-gray-700" data-id="element-364">{description}</p>
      </div>
    </div>;
}